import { pageMetaStore as e } from "./pageMetaStore.mjs";
import { useEffect as t } from "react";
//#region src/useSetPageMeta.ts
var n = (n) => {
	let r = n === void 0 ? void 0 : JSON.stringify(n);
	t(() => {
		if (r !== void 0) return e.set(JSON.parse(r)), () => e.set(null);
	}, [r]);
};
//#endregion
export { n as useSetPageMeta };
